module.exports = __webpack_public_path__ + "e3b5ae128fa785fb883633180f72eda0.png";